jQuery(document).ready(function($) {
	  $('#slider').royalSlider({
		arrowsNav: false,
		loop: true,
		keyboardNavEnabled: true,
		controlsInside: false,
		imageScaleMode: 'fill',
		arrowsNavAutoHide: false,
		autoScaleSlider: true, 
		controlNavigation: 'bullets',
		thumbsFitInViewport: false,
		navigateByClick: true,
		startSlideId: 0,
		autoPlay: false,
		slidesSpacing: 0,
		autoScaleSliderWidth: 800,
		autoScaleSliderHeight: 525,
		
	  });
	});
	
	
	$(function(){
		$('#menuShow').click(function(e){
			e.preventDefault();
			$('#overlay').show();
		})
		
	});
	
	$(function(){
		$('#menuHide').click(function(e){
			e.preventDefault();
			$('#overlay').hide();
		})
		
	});
	
	
	$(function(){
		$('#clickList').click(function(e){
			e.preventDefault();
			$('ul.hidden').show();
		})
		
	});